import { useState } from 'react';
import DotSpinner from '../shared/DotSpinner';

export function GiftsList({ gifts, loading, renderAction, renderNotGifts }) {
  const [selectedIndex, setSelectedIndex] = useState(-1);

  return (
    <div className="flex-1 overflow-y-auto px-4">
      {loading && <DotSpinner className="m-auto" />}

      <div className="grid grid-cols-3 gap-2 pb-4">
        {gifts.map((gift, index) => {
          const isSelected = selectedIndex === index;

          return (
            <div
              key={gift._id}
              className={`relative bg-[#0B6666]/30 rounded-[13px] cursor-pointer overflow-hidden min-h-[128px] ${
                isSelected ? 'border-2 border-[#A1F69E]' : ''
              }`}
              onClick={() => setSelectedIndex((prev) => (prev === index ? null : index))}
            >
              <div className="flex flex-col items-center pt-3 pb-2">
                <img
                  src={gift.imageUrl}
                  className={`transition-all duration-200 ${isSelected ? 'w-[20px] h-[20px]' : 'w-[50px] h-[50px]'}`}
                />
                <p className="text-[11px] text-center mt-1 text-white min-h-[33px]">{gift.title}</p>

                <div className="flex items-center gap-1 mt-1">
                  <img src="/icons/coin.svg" className="w-[11px] h-[11px]" />
                  <span className="text-[11px] text-white">{gift.priceCoins}</span>
                </div>
              </div>

              {renderAction && renderAction(gift, isSelected)}
            </div>
          );
        })}
      </div>
      {gifts.length === 0 && !loading && renderNotGifts()}
    </div>
  );
}
